import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 79F68E60-010F-4A8E-8E30-06CB64A5DBF6
 * name play-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-circle.svg
 * tags
 */
export const PlayCircleIcon = createSvgIcon(<><path d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'PlayCircleIcon');
export default PlayCircleIcon